module.exports = __webpack_public_path__ + "img/vocabulary-4-en.814159ca.png";